import { Alert, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { canEditBoletim } from "../../../../Utils/permissions";

const InfoRow = ({ label, value }) => (
  <div className="info-row">
    <span className="info-label">{label}</span>
    <span className="info-value">{value || "-"}</span>
  </div>
);

const BoletimInformacoes = ({ boletim, setBoletim }) => {
  const navigate = useNavigate();
  const podeEditar = canEditBoletim(boletim);

  if (!boletim) {
    return (
      <Alert variant="danger" className="mt-3 text-center">
        Boletim não encontrado
      </Alert>
    );
  }

  return (
    <div className="boletim-panel mt-3">
      <div
        className="boletim-header"
        onClick={() => {
          setBoletim(boletim);
          navigate(`/boletins/${encodeURIComponent(boletim._id)}`);
        }}
      >
        {boletim.natureza?.toUpperCase() || "NATUREZA NÃO INFORMADA"}
      </div>

      <InfoRow label="Data" value={boletim.occurrenceDateLabel || boletim.data} />
      <InfoRow label="Hora" value={boletim.occurrenceTimeLabel || boletim.horario} />
      <InfoRow label="Número" value={boletim.numero} />
      <InfoRow label="Município" value={boletim.municipio} />
      <InfoRow label="Bairro / localidade" value={boletim.bairro || boletim.localidadeNome} />

      <div className="boletim-actions">
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => {
            setBoletim(boletim);
            navigate(`/boletins/${encodeURIComponent(boletim._id)}`);
          }}
        >
          Ver
        </Button>

        {podeEditar && (
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => {
              setBoletim(boletim);
              navigate("/boletim/header");
            }}
          >
            Editar
          </Button>
        )}
      </div>
    </div>
  );
};

export default BoletimInformacoes;
